// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bb93","right":"styles_right__1GC2F"};